/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Get_For_FreeInputs */

const en_get_for_free = /** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GET FOR FREE`)
};

const id_get_for_free = /** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DAPATKAN SECARA GRATIS`)
};

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const es_get_for_free = en_get_for_free;

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const fr_get_for_free = en_get_for_free;

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const de_get_for_free = en_get_for_free;

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const ja_get_for_free = en_get_for_free;

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const zh_get_for_free = en_get_for_free;

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const ar_get_for_free = en_get_for_free;

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const it_get_for_free = en_get_for_free;

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const ru_get_for_free = en_get_for_free;

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const pt_get_for_free = en_get_for_free;

/** @type {(inputs: Get_For_FreeInputs) => LocalizedString} */
const ko_get_for_free = en_get_for_free;

/**
* | output |
* | --- |
* | "GET FOR FREE" |
*
* @param {Get_For_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const get_for_free = /** @type {((inputs?: Get_For_FreeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Get_For_FreeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_get_for_free(inputs)
	if (locale === "es") return es_get_for_free(inputs)
	if (locale === "fr") return fr_get_for_free(inputs)
	if (locale === "de") return de_get_for_free(inputs)
	if (locale === "ja") return ja_get_for_free(inputs)
	if (locale === "zh") return zh_get_for_free(inputs)
	if (locale === "ar") return ar_get_for_free(inputs)
	if (locale === "id") return id_get_for_free(inputs)
	if (locale === "it") return it_get_for_free(inputs)
	if (locale === "ru") return ru_get_for_free(inputs)
	if (locale === "pt") return pt_get_for_free(inputs)
	return ko_get_for_free(inputs)
});